export default {
  button_bar: {
    docx_button: {
      label: "Download i Word",
    },
    error: "Nogle felter mangler at blive udfyldt.",
    print_button: {
      label: "Print/gem som PDF",
    },
  },
  form: {
    shared: {
      validation_error: "Dette felt skal udfyldes",
      cvr_error: "Indtast et gyldigt CVR-nummer",
    },
    parties: {
      company: {
        headline: "Den udleverende part",
        name: {
          label: "Navn",
          placeholder: "Udleverende parts navn",
        },
        cvr: {
          label: "CVR-nummer",
          placeholder: "Udleverende parts CVR-nummer",
        },
        address: {
          label: "Adresse",
          placeholder: "Udleverende parts adresse",
        },
      },
      supplier: {
        headline: "Den modtagende part",
        name: {
          label: "Navn",
          placeholder: "Den modtagende parts navn",
        },
        cvr: {
          label: "CVR-nummer",
          placeholder: "Den modtagende parts CVR-nummer",
        },
        address: {
          label: "Adresse",
          placeholder: "Den modtagende parts adresse",
        },
      },
    },
    agreement: {
      headline: "Aftalen",
      description: {
        label: "Aftalebeskrivelse",
        placeholder: "Kort beskrivelse af aftalen",
      },
      date: {
        label: "Dato",
        placeholder: "Aftale indgået d.",
      },
    },
    violation: {
      headline: "Overtrædelse",
      amount: {
        label: "Konventionalbod",
        placeholder: "Konventionalbod i kr.",
      },
    },
    applicableLaw: {
      headline: "Lovvalg og værneting",
      rule_types: {
        label: "Tvister afgøres ved:",
        voldgiftinstitut:
          "ved voldgift efter reglerne ved Det danske Voldgiftinstitut",
        court: "efter reglerne ved de almindelige domstole",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/apps/hemmelig/translations/form/en_form.js